<template>

  <!-- ---------------------------------------------------------------- -->
  <!-- --------------------------- Form ------------------------------- -->
  <!-- ---------------------------------------------------------------- -->

  <div class="pagesMainDiv">
  
    <div class="pageHeader" style="margin-bottom: 15px;">
        <span class="pageHeader">{{ pageTitle }}</span>
    </div>
  
    <!-- ------------------------------------------- -->
    <!-- ----------------- Group 1 ----------------- -->
    <!-- ------------------------------------------- -->

    <div class="formContainer groupMinWidth">
  
      <!-- --------------------------------------------- -->
      <!-- ------------ left column -------------------- -->
      <!-- --------------------------------------------- -->

      <div class="leftRightRowContainer borderRed">

        <!-- ----------------- Password ---------------- -->

        <div class="elementRight">
          <span class="labelFont">Password: </span>
        </div>

        <div class="elementLeft">
          <input id="passwordID" 
          tabindex="1"
          placeholder="Enter New Password"
          class="ctrlFont ctrlBorderRadius ctrlTextPadding"
          v-model="passwordText" 
          :size="textboxLength"
          autocomplete="off" 
          type="password">

          <span v-if="passwordValidationError" class="highlightRed validationErrorAsterisk">!!</span>

        </div>

        <!-- ----------------- First Name ---------------- -->
        
        <div class="elementRight">
          <span class="labelFont">First Name: </span>
        </div>

        <div class="elementLeft">
          <input tabindex="6" class="ctrlFont ctrlBorderRadius ctrlTextPadding" v-model="firstName" maxlength="20" :size="textboxLength" type="text">
        </div>

        <!-- ----------------- Email ---------------- -->  

        <div class="elementRight">
          <span class="labelFont">Email: </span>
        </div>

        <div class="elementLeft nowrapAll">
          <input tabindex="9" class="ctrlFont ctrlBorderRadius  ctrlTextPadding " v-model="email" maxlength="120" :size="textboxLength" type="text">
          <span v-if="!emailValidationError" class="validationErrorAsterisk">*</span>
          <span v-if="emailValidationError" class="highlightRed validationErrorAsterisk">!!</span>
        </div>

        <!-- ----------------- Rank ---------------- -->

        <div class="elementRight">
          <span class="labelFont">Rank: </span>
        </div>

        <div class="elementLeft nowrapAll">
          
          <select tabindex="12" id="serviceRankId" 
                  class="ctrlBorderRadius ctrlDropDown ctrlFont"
                  v-model="serviceRankId" 
                  style="margin: 0px">
            <option v-for="item in rankList" 
                    :value="item.serviceRankId" 
                    :key="item.serviceRankId">
              {{ item.serviceRankAcronym }}
            </option>
          </select>

          <span v-if="!serviceRankIdValidationError" class="validationErrorAsterisk">*</span>
          <span v-if="serviceRankIdValidationError" class="highlightRed validationErrorAsterisk">!!</span>
        </div>

        <!-- ----------------- User Name ---------------- -->

        <div class="elementRight">
          <span class="labelFont">User Name: </span>
        </div>

        <div class="elementLeft">
          <input tabindex="99" class="ctrlFont ctrlBorderRadius  ctrlTextPadding " 
                 v-model="email" disabled maxlength="20" :size="textboxLength" type="text">
        </div>

      </div>

      <!-- --------------------------------------------- -->
      <!-- ------------ middle column ------------------ -->
      <!-- --------------------------------------------- -->

      <div class="leftRightRowContainer borderBlue">

        <!-- ----------------- Is Active ---------------- -->

        <div v-if="!userIsAnAdmin">&nbsp;</div>
        <div v-if="!userIsAnAdmin">&nbsp;</div>

        <div v-if="userIsAnAdmin" class="elementRight">
          <span class="labelFont">Is Active: </span>
        </div>

        <div v-if="userIsAnAdmin" class="elementLeft">
          <input tabindex="2" :checked="(isActive == true)" class="labelFont" type="radio" name="isActive" id="activeID">
          <span class="radioLabelMargin labelFont">Yes</span>
          <input tabindex="3" :checked="(isActive == false)" class="labelFont" type="radio" name="isActive" id="inactiveID" style="margin-left: 15px;">
          <span class="radioLabelMargin labelFont">No</span>
          <span v-if="!isActiveValidationError" class="validationErrorAsterisk">*</span>
          <span v-if="isActiveValidationError" class="highlightRed validationErrorAsterisk">!!</span>
        </div>

        <!-- ----------------- Middle Name ---------------- -->

        <div class="elementRight">
          <span class="labelFont">Middle Name: </span>
        </div>

        <div class="elementLeft">
          <input tabindex="7" class="ctrlFont ctrlBorderRadius  ctrlTextPadding " v-model="middleName" maxlength="20" :size="textboxLength" type="text">
        </div>

        <!-- ----------------- Phone ---------------- -->

        <div class="elementRight">
          <span class="labelFont">Phone: </span>
        </div>

        <div class="elementLeft">
          <input tabindex="10" class="ctrlFont ctrlBorderRadius  ctrlTextPadding " v-model="phone1" maxlength="20" :size="textboxLength" type="text">
        </div>

        <!-- ----------------- Role ---------------- -->

        <div class="elementRight">
          <span class="labelFont">Role: </span>
        </div>

        <div class="elementLeft nowrapAll">

          <select id="roleId" 
                  tabindex="13"
                  class="ctrlBorderRadius ctrlDropDown ctrlFont"
                  v-model="roleId"
                  @change="roleChangeEventHandler"
                  style="margin: 0px">
            <option v-for="item in roleList" 
                    :value="item.roleId" 
                    :key="item.roleId">
              {{ item.roleAcronym }}
            </option>
          </select>

          <span v-if="!roleValidationError" class="validationErrorAsterisk">*</span>
          <span v-if="roleValidationError" class="highlightRed validationErrorAsterisk">!!</span>
        </div>

        <!-- ----------------- Certificate Common Name ---------------- -->

        <div class="elementRight">
          <span class="labelFont">Certificate Name: </span>
        </div>
        
        <div class="elementLeft">
          <input tabindex="17" class="ctrlFont ctrlBorderRadius  ctrlTextPadding " v-model="certificatCommonName" maxlength="75" :size="textboxLength" type="text">
        </div>

      </div>
      
      <!-- --------------------------------------------- -->
      <!-- ------------ right column ------------------- -->
      <!-- --------------------------------------------- -->

      <div class="leftRightRowContainer borderPink">


        <!-- ----------------- Deleted ---------------- -->

        <div class="elementRight">
          <span class="labelFont">Deleted: </span>
        </div>

        <div class="elementLeft">
          <input tabindex="4" :checked="(deleted == true)" class="labelFont" type="radio" name="Deleted" id="deletedYesID">
          <span class="radioLabelMargin labelFont">Yes</span>
          <input tabindex="5" :checked="(deleted == false)" class="labelFont" type="radio" name="Deleted" style="margin-left: 15px;" id="deletedNoID">
          <span class="radioLabelMargin labelFont">No</span>
        </div>

        <!-- ----------------- Last Name ---------------- -->

        <div class="elementRight">
          <span class="labelFont">Last Name: </span>
        </div>

        <div class="elementLeft nowrapAll">
          <input tabindex="8" class="ctrlFont ctrlBorderRadius  ctrlTextPadding " v-model="lastName" maxlength="20" :size="textboxLength" type="text">
          <span v-if="!lastNameValidationError" class="validationErrorAsterisk">*</span>
          <span v-if="lastNameValidationError" class="highlightRed validationErrorAsterisk">!!</span>
        </div>

        <!-- ----------------- Title ---------------- -->  

        <div class="elementRight">
          <span class="labelFont">Title: </span>
        </div>

        <div class="elementLeft">
          <input tabindex="11" class="ctrlFont ctrlBorderRadius  ctrlTextPadding " v-model="title" maxlength="20" :size="textboxLength" type="text">
        </div>

        <!-- ----------------- ReDeploy Date ---------------- -->

        <div class="elementRight">
          <span class="labelFont">ReDeploy Date: </span>
        </div>
        
        <div class="elementLeft">

          <input tabindex="14" type="date" class="ctrlFont ctrlBorderRadius ctrlTextPadding" v-model="redeployDate" />

        </div>

      </div>
  
    </div>

    <!-- ------------------------------------------- -->
    <!-- ----------------- Group 2 ----------------- -->
    <!-- ------------------------------------------- -->

    <div class="formContainer groupMinWidth">

      <div class="leftRightRowContainerAlt borderPink">


        <!-- ----------------- Camp Location ---------------- -->  

        <div class="elementRight">
          <span class="labelFont">Camp Location: </span>
        </div>

        <div class="elementLeft nowrapAll">

          <select tabindex="16" id="campLocationId" 
                  class="ctrlBorderRadius ctrlDropDown ctrlFont"
                  v-model="campLocationId" 
                  style="margin: 0px">
            <option v-for="item in campLocationList" 
                    :value="item.campLocationId" 
                    :key="item.campLocationId">
              {{ item.campName }}
            </option>
          </select>
          
          <span v-if="!campLocationIdValidationError" class="validationErrorAsterisk">*</span>
          <span v-if="campLocationIdValidationError" class="highlightRed validationErrorAsterisk">!!</span>
        </div>


        <!-- ----------------- Country ---------------- -->

        <div class="elementRight">
          <span class="fontAll labelFont">Country: </span>
        </div>

        <div class="elementLeft nowrapAll">

          <select tabindex="18" id="countryId" 
                  class="ctrlBorderRadius ctrlDropDown ctrlFont"
                  v-model="countryId" 
                  style="margin: 0px">
            <option v-for="item in countryList" 
                    :value="item.countryId" 
                    :key="item.countryId">
              {{ item.countryName }}
            </option>
          </select>

          <span v-if="!countryIdValidationError" class="validationErrorAsterisk">*</span>
          <span v-if="countryIdValidationError" class="highlightRed validationErrorAsterisk">!!</span>
        </div>

        <!-- ----------------- Company ---------------- -->

        <div class="elementRight">
          <span class="labelFont">Company: </span>
        </div>

        <div v-if="userIsVendor" class="elementLeft nowrapAll">

          <select id="companyId" 
                  tabindex="19"
                  class="ctrlBorderRadius ctrlDropDown ctrlFont"
                  v-model="companyId" 
                  style="margin: 0px">
            <option v-for="item in companyList" 
                    :value="item.companyId" 
                    :key="item.companyId">
              {{ item.companyName }}
            </option>
          </select>

          <span v-if="!companyIdValidationError" class="validationErrorAsterisk">*</span>
          <span v-if="companyIdValidationError" class="highlightRed validationErrorAsterisk">!!</span>
        </div>

        <div v-if="!userIsVendor" class="elementLeft nowrapAll">

          <select id="companyId" 
                  tabindex="19"
                  disabled
                  class="ctrlBorderRadius ctrlDropDown ctrlFont"
                  v-model="companyId" 
                  style="margin: 0px">
            <option v-for="item in companyList" 
                    :value="item.companyId" 
                    :key="item.companyId">
              {{ item.companyName }}
            </option>
          </select>

        </div>

      </div>

    </div>

    <!-- ------------------------------------------- -->
    <!-- ----------------- Group 3 ----------------- -->
    <!-- ------------------------------------------- -->

    <div class="formContainer groupMinWidth" style="margin-top: 10px;">

      <div class="leftRightRowContainerAlt borderPink">

        <!-- ----------------- User Profile Notes ---------------- -->

        <div class="elementRight">
          <span class="fontAll labelFont">User Profile Notes: </span>
        </div>

        <div class="elementLeft">

          <textarea class="ctrlFont ctrlBorderRadius  ctrlTextPadding " 
                    style="resize: none;"
                    tabindex="20"
                    rows="3" 
                    cols="40" 
                    v-model="userProfileNotes" >
          </textarea>

        </div>


      </div>

    </div>
  
    <!-- ------------------------------------------- -->
    <!-- ----------------- Group End -------------- -->
    <!-- ------------------------------------------- -->

  </div>

  <!-- ---------------------------------------------------------------- -->
  <!-- --------------------------- Validation ------------------------- -->
  <!-- ---------------------------------------------------------------- -->

  <div class="itemCenterCenter">

  <div  v-if="showValidationResults" class="validationDiv">

    <div class="validationHeaderDiv">Form Validation</div>

    <table class="valTableMargin">
    <tr>
      <td  style="text-align: center" colspan="2" class="highlightDarkRed" >The validation issues are the following:</td>
    </tr>
    <tr  v-if="passwordValidationError">
      <td class="valCellLeft fontSizeAll">Password</td>
      <td class="valCell fontSizeAll">
        <ul>
          <li>At Least 15 Characters</li>
          <li>At Least 1 Upper Case Character (A-Z)</li>
          <li>At Least 1 Lower Case Character (a-z)</li>
          <li>At Least 1 Number (0-9)</li>
          <li>At Least 1 Special Character (#?!@$%^&*-)</li>
        </ul>
      </td>
    </tr>
    <tr  v-if="isActiveValidationError">
      <td class="valCellLeft fontSizeAll">Is Active</td>
      <td class="valCell fontSizeAll">No Selection Made</td>
    </tr>
    <tr v-if="lastNameValidationError">
      <td class="valCellLeft fontSizeAll">Last Name</td>
      <td class="valCell fontSizeAll">Field is blank</td>
    </tr>
    <tr v-if="emailValidationError">
      <td class="valCellLeft fontSizeAll" >Email</td>
      <td v-if="emailValidationErrorReason.fieldIsUndefined" class="valCell fontSizeAll">Field is blank</td>
      <td v-if="emailValidationErrorReason.nameIsACopy" class="valCell fontSizeAll">
        <div>The selected Email is a duplicate of an existing email.</div>
        <div>The current Emails are the following: 
          <select id="roleId" 
                  class="ctrlBorderRadius ctrlDropDown ctrlFont"
                  style="margin: 0px">
            <option v-for="item in userNamesList" 
                    :value="item.name" 
                    :key="item.name">
              {{ item.name }}
            </option>
          </select>
        </div>
      </td>
    </tr>
    <tr v-if="serviceRankIdValidationError">
      <td class="valCellLeft fontSizeAll">Rank</td>
      <td class="valCell fontSizeAll">No Selection Made</td>
    </tr>
    <tr v-if="roleValidationError">
      <td class="valCellLeft fontSizeAll">Role</td>
      <td class="valCell fontSizeAll">No Selection Made</td>
    </tr>
    <tr v-if="campLocationIdValidationError">
      <td class="valCellLeft fontSizeAll">Camp Location</td>
      <td class="valCell fontSizeAll">No Selection Made</td>
    </tr>
    <tr v-if="countryIdValidationError">
      <td class="valCellLeft fontSizeAll">Country</td>
      <td class="valCell fontSizeAll">No Selection Made</td>
    </tr>
    <tr v-if="companyIdValidationError">
      <td class="valCellLeft fontSizeAll">Company</td>
      <td class="valCell fontSizeAll">No Selection Made</td>
    </tr>
    </table>

    <div class="validationHeaderDiv" style="margin-top: 15px;">
      <button class="btn btn-primary fontSizeBtn" 
              @click='handleHideValidation' 
              id="tbnHideID"
              type="button">Hide
      </button>
    </div>

  </div>

  </div>

  <!-- ---------------------------------------------------------------- -->
  <!-- --------------------------- Confirmation ----------------------- -->
  <!-- ---------------------------------------------------------------- -->

  <div class="itemCenterCenter">

  <div  v-if="showConfirmation" class="validationDiv">

    <div v-if="actionIsCreate" class="validationHeaderDiv">User Successfully added to Database</div>
    <div v-if="actionIsEdit" class="validationHeaderDiv">User Successfully Updated</div>

    <table class="valTableMargin">
      <tr>
        <td colspan="2" style="text-align: center" class="highlightDarkRed" >Subset of fields</td>
      </tr>
      <tr>
        <td class="valCellLeft fontSizeAll">User Profile ID</td>
        <td class="valCell fontSizeAll">{{ confirmUserProfileId }}</td>
      </tr>
      <tr>
        <td class="valCellLeft fontSizeAll" >Last Name</td>
        <td class="valCell fontSizeAll">{{ confirmedLastName }}</td>
      </tr>
      <tr>
        <td class="valCellLeft fontSizeAll">Email</td>
        <td class="valCell fontSizeAll">{{ confirmedUserEmail }}</td>
      </tr>
    </table>

    <button class="btn btn-primary fontSizeBtn" 
          style="margin-top: 20px;"
          @click='handleHideConfirmationResults' 
          id="tbnClearID"
          type="button">Hide Results</button>

  </div>

  </div>

  <!-- ---------------------------------------------- -->
  <!-- ------------- Controls Start ----------------- -->
  <!-- ---------------------------------------------- -->

  <div class="mainContainer" style="white-space: nowrap;">
    <div></div>
    <div>
      <button class="btn btn-primary fontSizeBtn" 
            @click='handleBackToPreviousPage' 
            id="tbnCreateID"
            type="button">Back to Previous Page
      </button>

      <button class="btn btn-danger fontSizeBtn" 
            @click='handleBackToPreviousPage' 
            id="tbnClearID"
            type="button">Cancel
      </button>

      <button class="btn btn-primary fontSizeBtn" 
            @click='handleSubmit' 
            id="tbnClearID"
            type="button">Submit
      </button>

    </div>
    <div></div>
  </div>

  <!-- ---------------------------------------------- -->
  <!-- ------------- Controls End ------------------- -->
  <!-- ---------------------------------------------- -->    

</template>
    
<script>
    import axios from "axios";
    import { store } from "../../../../store/store.js";
  
    export default {
      data() {return{
        //-------------------- Logging --------------------------------------
        logTrace: false,
        logData: false,
        logLists: false,

        //-------------------- Role --------------------------------------

        userIsAnAdmin: false,
        userRole: null,

        //-------------------- Validation --------------------------------------
        
        validationErrorsFound: false,
        showValidationResults: false,

        emailValidationError: false,
        emailValidationErrorReason: null,
        lastNameValidationError: false,

        serviceRankIdValidationError: false,
        roleValidationError: false,
        countryIdValidationError: false,
        companyIdValidationError: false,
        campLocationIdValidationError: false,
        passwordValidationError: false,

        isActiveValidationError: false,

        //-------------------- Confirmation --------------------------------------
        confirmUserProfileId: null,
        confirmedLastName: null,
        confirmedUserEmail: null,
        showConfirmation: false,
        
        //-------------------- Page Actions --------------------------------------
        actionIsEdit: false,
        actionIsCreate: false,
        actionIsNonAdminEdit: false,

        pageTitle: null,

        //-------------------- Common Length --------------------------------------
        textboxLength: 20,
  
        //-------------------- IDs --------------------------------------
        userProfileId: null,
        userGUID: null,
  
        //-------------------- Lists --------------------------------------

        //------- Rank
        rankList: null,
        defaultRankList: { serviceRankId: -1, serviceRankAcronym: 'Please Select a Value' },
        serviceRankId: -1,

        //------- Role
        roleList: null,
        defaultRoleList: { roleId: -1, roleAcronym: 'Please Select a Value' },
        roleId: -1,
        vendorRoleId: -1,
        roleName: null,
        userIsVendor: null,
  
        //------- Country
        countryList: null,
        defaultCountryList: { countryId: -1, countryName: 'Please Select a Value' },
        countryId: -1,

        //------- Company
        companyList: null,
        defaultCompanyList: { companyId: -1, companyName: 'Please Select a Value' },
        companyId: -1,
                
        //------- Camp Location
        campLocationList: null,
        defaultCampLocationList: { campLocationId: -1, campName: 'Please Select a Value' },
        campLocationId: -1,
  
        //------- User Names
        userNamesList: null,

        // -------------------- Textbox Fields --------------------------------------
        firstName: null,
        lastName: null,
        middleName: null,
        email: null,
        originalEmail: null,
        phone1: null,
        title: null,
        userProfileNotes: null,
        certificatCommonName: null,
        userName: null,
        passwordText: null,
  
        //-------------------- Radio Buttons --------------------------------------
        isActive: null,
        deleted: null,
  
        //-------------------- Dates --------------------------------------
        redeployDate: null,
  
        //-------------------- User Profile --------------------------------------
        userProfileRecord: null,
        };
      },
      watch: {},
      created() {
        if (this.$data.logTrace) {console.log('*** created ***');}

        this.setUserRole();
        this.clearValidation();
        this.captureRoutingParameters();
      },
  
      components: {},
      computed: {

        UserProfileId() {
          return store.authenticatedUser.userProfileId != null
            ? store.authenticatedUser.userProfileId
            : store.tempUserProfileId;
        },

      },
      mounted () {
        if (this.$data.logTrace) {console.log('*** mounted ***');}
        this.$data.passwordText = null;
    },
  
      methods: {
  
        // ----------- User Role --------------

        setUserRole(){

          console.log('store.authenticatedUser.roleName = ', store.authenticatedUser.roleName);

          this.$data.userRole = store.authenticatedUser.roleName;

          if (this.$data.userRole == 'Admin') {
            this.$data.userIsAnAdmin = true;
          } else {
            this.$data.userIsAnAdmin = false;
          }
          
        },

        // ----------- handle events --------------

        roleChangeEventHandler(){
          console.log('roleChangeEventHandler: this.$data.roleId = ', this.$data.roleId);
          if (this.$data.roleId !=this.$data.vendorRoleId) {
            this.$data.userIsVendor = false;
            this.$data.companyId = -1;
          } else {
            this.$data.userIsVendor = true;
          }

        },

        handleHideConfirmationResults(){
          this.$data.showConfirmation = false;
        },

        handleActiveRadioClick(){
          if (this.$data.logTrace) {console.log('*** handleActiveRadioClick ***');}

        },

        handleBackToPreviousPage() {
          if (this.$data.logTrace) {console.log('*** handleBackToPreviousPage ***');}
  
          this.$router.push({ name: 'userRecords' });
        },

        handleSubmit() {
          if (this.$data.logTrace) {console.log('*** handleSubmit ***');}

          this.$data.showConfirmation = false;

          this.validateFields();

          if (this.$data.validationErrorsFound == false) {

            let formData = new FormData();
            
            if (this.$data.actionIsEdit == true) {
              formData.append("action","edit");
              formData.append("userProfileId",this.$data.userProfileId);
              formData.append("updaterUserProfileId",this.UserProfileId);
            } else if (this.$data.actionIsCreate == true) {
              formData.append("action","create");
              formData.append("userProfileId",this.UserProfileId);
            } else {
              formData.append("action","undefined");
              formData.append("userProfileId",-1);
            }

            this.setDeletedValue();

            let yesDeletedCtrl = document.querySelector("#deletedYesID");
            let noDeletedCtrl = document.querySelector("#deletedNoID");
            let yesActiveCtrl = document.querySelector("#activeID");
            let noActiveCtrl = document.querySelector("#inactiveID");
            
            formData.append("password",this.$data.passwordText);
            formData.append("isActive",this.$data.isActive);
            formData.append("deleted",this.$data.deleted);
            formData.append("firstName",this.$data.firstName);
            formData.append("middleName",this.$data.middleName);
            formData.append("lastName",this.$data.lastName);
            formData.append("email",this.$data.email);
            formData.append("phone1",this.$data.phone1);
            formData.append("title",this.$data.title);
            formData.append("serviceRankId",this.$data.serviceRankId);
            formData.append("roleId",this.$data.roleId);
            formData.append("redeployDate",this.$data.redeployDate);
            formData.append("campLocationId",this.$data.campLocationId);
            formData.append("certificatCommonName",this.$data.certificatCommonName);
            formData.append("countryId",this.$data.countryId);
            formData.append("companyId",this.$data.companyId);
            formData.append("userProfileNotes",this.$data.userProfileNotes);

            if (this.$data.actionIsEdit == true) {

              axios
              .post(store.webAPIUrl + "UserProfile/UpdateUser/",formData)
              .then((response) => response.data)
              .then((data) => {

                this.$data.confirmUserProfileId = data.userProfileId;
                this.$data.confirmedLastName = data.lastName;
                this.$data.confirmedUserEmail = data.email;

                this.$data.showConfirmation = true;
              });

            } else if (this.$data.actionIsCreate == true) {

              axios
              .post(store.webAPIUrl + "UserProfile/CreateUser/",formData)
              .then((response) => response.data)
              .then((data) => {

                this.$data.confirmUserProfileId = data.userProfileId;
                this.$data.confirmedLastName = data.lastName;
                this.$data.confirmedUserEmail = data.email;

                this.$data.showConfirmation = true;
              });

            }
            //Need to update this to prevent issues with validation.
            this.getUserNameList();

          }

        },

        handleHideValidation() {
          if (this.$data.logTrace) {console.log('*** handleHideValidation ***');}

          this.$data.showValidationResults = false;

        },

        validateFields() {

          this.clearValidation();

          this.validateActiveRadioBtn();

          this.validateUserName(this.$data.email);

          this.$data.lastNameValidationError = this.validateTextboxErrorsFound(this.$data.lastName);

          if (this.$data.roleId == this.$data.vendorRoleId) {
            this.$data.userIsVendor = true;
          } else {
            this.$data.userIsVendor = false;
          }

          this.$data.serviceRankIdValidationError  = (this.$data.serviceRankId  == -1);
          this.$data.roleValidationError           = (this.$data.roleId         == -1);
          this.$data.countryIdValidationError      = (this.$data.countryId      == -1);
          this.$data.companyIdValidationError      = (this.$data.companyId      == -1);
          this.$data.campLocationIdValidationError = (this.$data.campLocationId == -1);
          this.$data.passwordValidationError       = this.validatePassword();

          if (this.$data.userIsVendor == false) {
            this.$data.companyIdValidationError = false;
          }

          this.$data.validationErrorsFound = 
          this.$data.serviceRankIdValidationError   || this.$data.roleValidationError       || 
          this.$data.countryIdValidationError       || this.$data.companyIdValidationError  || 
          this.$data.campLocationIdValidationError  || this.$data.lastNameValidationError   ||
          this.$data.emailValidationError           || this.$data.isActiveValidationError   ||
          this.$data.passwordValidationError;

          this.$data.showValidationResults = this.$data.validationErrorsFound;

        },

        validatePassword(){
          let validationErrorWasFound = false;

          if (this.$data.passwordText != null) {
            if (this.$data.passwordText.trim().length == 0) {
              this.$data.passwordText = null;
            } else if (this.$data.passwordText.trim().length > 0) {
              //At least 15 characters,
              //At least 1 Upper Case letter,
              //At least 1 Lower Case letter,
              //At least one number (0-9)
              //At lesat on special charater: #?!@$%^&*-

              // console.log('this.$data.passwordText = ', this.$data.passwordText);

              if ((this.$data.passwordText.trim().length < 15) ||
                 (/[#?!@$%^&*-]/.test(this.$data.passwordText) == false ) ||
                 (/[A-Z]/.test(this.$data.passwordText) == false )        ||
                 (/[a-z]/.test(this.$data.passwordText) == false )        ||
                 (/[0-9]/.test(this.$data.passwordText) == false )) {
                  validationErrorWasFound = true;
                 }
            }
          }
          return validationErrorWasFound;
        },

        validateUserName(userName){

          let fieldIsUndefined = false;
          let nameIsACopy = false;

          if (this.validateTextboxErrorsFound(userName) == true) {
            fieldIsUndefined = true;
          } else {

            let nameFound = false;

            this.$data.userNamesList.forEach((nameObj) => { 
              // console.log(`name (${name})  userName (${userName})`);
              if (nameObj.name.trim() == userName.trim()) {
                if ((this.$data.actionIsEdit) && (nameObj.name.trim() != this.$data.originalEmail.trim())) {
                  nameFound = true;
                  return;
                } else if (this.$data.actionIsCreate) {
                  nameFound = true;
                  return;
                }
              }
            });

            if (nameFound == true) {
              nameIsACopy = true;
            }

          }

          this.$data.emailValidationErrorReason = {};
          this.$data.emailValidationErrorReason['fieldIsUndefined'] = fieldIsUndefined;
          this.$data.emailValidationErrorReason['nameIsACopy'] = nameIsACopy;

          if (fieldIsUndefined || nameIsACopy) {
            this.$data.emailValidationError = true;
          } else {
            this.$data.emailValidationError = false;
          }
        },

        clearValidation() {
          this.$data.validationErrorsFound = false;
          this.$data.showValidationResults = false;

          this.$data.emailValidationError = false;
          this.$data.lastNameValidationError = false;

          this.$data.serviceRankIdValidationError = false;
          this.$data.roleValidationError = false;
          this.$data.countryIdValidationError = false;
          this.$data.companyIdValidationError = false;
          this.$data.campLocationIdValidationError = false;
          this.$data.passwordValidationError = false;

          this.$data.isActiveValidationError = false;
        },

        setDeletedValue() {
          let deletedYes = document.querySelector('#deletedYesID');
          let deletedNo = document.querySelector('#deletedNoID');

          if ((deletedYes != null) && (deletedNo != null)) {

            if (deletedYes.checked == true){
              this.$data.deleted = true;
            } else if (deletedNo.checked == true) {
              this.$data.deleted = false;
            }

          }
          
        },

        validateActiveRadioBtn () {
          let activeYes = document.querySelector('#activeID');
          let activeNo = document.querySelector('#inactiveID');

          if ((activeYes != null) && (activeNo != null)) {

            if ((activeYes.checked == false) && (activeNo.checked == false)) {
              this.$data.isActiveValidationError = true;
            } else {
              if (activeYes.checked == true) {
                this.$data.isActive = true;
              } else {
                this.$data.isActive = false;
              }
            }
            
          } else {
            this.$data.isActiveValidationError = false;
          }

        },

        validateTextboxErrorsFound(fieldValue) {
          let errorfound = false;
          if (fieldValue == null) {
            errorfound = true;
          } else if (fieldValue.trim().length == 0) {
            errorfound = true;
          }
          return errorfound;
        },

        //------------------ User -----------------------------
                
        captureRoutingParameters() {
          if (this.$data.logTrace) {console.log('*** captureRoutingParameters ***');}

          this.$data.actionIsEdit = false;
          this.$data.actionIsCreate = false;
          this.$data.actionIsNonAdminEdit = false;

          // console.log('this.$route.params.actionIsEdit = ', this.$route.params.actionIsEdit);
          // console.log('this.$route.params.actionIsCreate = ', this.$route.params.actionIsCreate);
          // console.log('this.$route.params.actionIsNonAdminEdit = ', this.$route.params.actionIsNonAdminEdit);

          if (this.$route.params.actionIsEdit == 'true') {
            this.$data.actionIsEdit = true;
            this.$data.pageTitle = 'Edit User';

            this.$data.userProfileId = this.$route.params.userProfileIdParam;
            this.$data.userGUID      = this.$route.params.userGUIDParam;
            this.$data.lastName      = this.$route.params.lastNameParam;

          } else if (this.$route.params.actionIsCreate == 'true') {
            this.$data.actionIsCreate = true;
            this.$data.pageTitle = 'Create User';

            this.$data.userProfileId = null;
            this.$data.userGUID      = null;
            this.$data.lastName      = null;

          } else if (this.$route.params.actionIsNonAdminEdit == 'true') {
            this.$data.actionIsNonAdminEdit = true;
            this.$data.pageTitle = 'Edit My User Information';

            this.$data.userProfileId = this.$route.params.userProfileIdParam;
            this.$data.userGUID      = this.$route.params.userGUIDParam;
            this.$data.lastName      = this.$route.params.lastNameParam;

          }
  
          if (this.$data.logData) {
            console.log('pageTitle = ', this.$data.pageTitle);
            console.log('actionIsEdit = ', this.$data.actionIsEdit);
            console.log('actionIsCreate = ', this.$data.actionIsCreate);
            console.log('typeof = ', typeof this.$route.params.actionIsEdit);
            console.log('actionIsNonAdminEdit = ', this.$data.actionIsNonAdminEdit);

            console.log('userProfileId = ', this.$data.userProfileId);
            console.log('userGUID = ', this.$data.userGUID);
            console.log('firstName = ', this.$data.firstName);
            console.log('lastName = ', this.$data.lastName);
          }
  
          this.getUserForId();

        },
      
        getUserForId() {
          if (this.$data.logTrace) {console.log('*** getUserForId ***');}

          if (this.$data.actionIsCreate == true) {
            this.getRankList();
            this.getRoleList();
            this.getCountryList();
            this.getCompanyList();
            this.getCampLocationList();
            this.getUserNameList();
          }

          if (this.$data.actionIsCreate == false) {
          axios
            .get(store.webAPIUrl + "UserProfile/selUsersForId/" + this.$data.userProfileId)
            .then((response) => response.data)
            .then((data) => {
              this.$data.userProfileRecord = data[0];
              
              if (this.$data.logData) {
                console.log('this.$data.userProfileRecord = ', this.$data.userProfileRecord);
              }

              this.setAttributeValues();

              //The dropdown lists depend on attribute values being set.
              this.getRankList();
              this.getRoleList();
              this.getCountryList();
              this.getCompanyList();
              this.getCampLocationList();
              this.getUserNameList();

            });
          }
        },

        setAttributeValues() {
          if (this.$data.logTrace) {console.log('*** setAttributeValues ***');}

          this.$data.firstName  = this.$data.userProfileRecord.firstName;
          this.$data.lastName   = this.$data.userProfileRecord.lastName;
          this.$data.middleName = this.$data.userProfileRecord.middleName;
          this.$data.email      = this.$data.userProfileRecord.email;
          this.$data.originalEmail = this.$data.email;
          this.$data.phone1     = this.$data.userProfileRecord.phone1;
          this.$data.title      = this.$data.userProfileRecord.title;
          this.$data.userProfileNotes     = this.$data.userProfileRecord.userProfileNotes;
          this.$data.certificatCommonName = this.$data.userProfileRecord.certificatCommonName;
          this.$data.userName             = this.$data.userProfileRecord.userName;
          this.$data.serviceRankId = this.$data.userProfileRecord.serviceRankId;
          this.$data.roleId = this.$data.userProfileRecord.roleId;
          this.$data.roleName = this.$data.userProfileRecord.roleName;
          this.$data.countryId = this.$data.userProfileRecord.countryId;
          this.$data.companyId = this.$data.userProfileRecord.companyId;
          this.$data.campLocationId =  this.$data.userProfileRecord.campLocationId;
          this.$data.isActive =  this.$data.userProfileRecord.isActive;
          this.$data.deleted =  this.$data.userProfileRecord.deleted;

          this.$data.redeployDate =  this.$data.userProfileRecord.redeployDate;

          if (this.$data.roleName == "Vendor") {
            this.$data.userIsVendor = true;
          } else {
            this.$data.userIsVendor = false;
          }

          if (this.$data.redeployDate) {
            this.$data.redeployDate = this.formatDateFnc(this.$data.redeployDate);
          }

          this.logAllFields();

        },

        //------------------ Lists -----------------------------
    
        getRankList() {
          if (this.$data.logTrace) {console.log('*** getRankList ***');}

          axios
            .get(store.webAPIUrl + "UserProfile/SelAllServiceRank")
            .then((response) => response.data)
            .then((data) => {
              this.$data.rankList = data;

              //Add the default item to the top of the list.
              this.$data.rankList.unshift(this.$data.defaultRankList);

              let idFound = false;
              this.$data.rankList.forEach((item) =>{
                if (this.$data.serviceRankId == item['serviceRankId']) {
                  idFound = true;
                }
              });
              if (idFound == false) {
                this.$data.serviceRankId = this.$data.defaultRankList.serviceRankId;
              }

              if (this.$data.logLists) {
                console.log('this.$data.rankList = ', this.$data.rankList);
              }
            });
        },
    
        getRoleList() {
          if (this.$data.logTrace) {console.log('*** getRoleList ***');}

          axios
            .get(store.webAPIUrl + "UserProfile/SelAllRoles")
            .then((response) => response.data)
            .then((data) => {
              this.$data.roleList = data;
              this.$data.roleList.unshift(this.$data.defaultRoleList);

              let idFound = false;
              this.$data.roleList.forEach((item) =>{
                if (this.$data.roleId == item['roleId']) {
                  idFound = true;
                }
              });
              if (idFound == false) {
                this.$data.roleId = this.$data.defaultRoleList.roleId;
              }

              this.$data.roleList.forEach((item) =>{
                if (item['roleName'] == "Vendor") {
                  this.$data.vendorRoleId = item['roleId'];
                }
              });

              // console.log("this.$data.vendorRoleId = ", this.$data.vendorRoleId);

              if (this.$data.logLists) {
                console.log('this.$data.roleList = ', this.$data.roleList);
              }
            });
        },
    
        getCountryList() {
          if (this.$data.logTrace) {console.log('*** getCountryList ***');}

          axios
            .get(store.webAPIUrl + "Country/SelAllCountry")
            .then((response) => response.data)
            .then((data) => {
              this.$data.countryList = data;
              this.$data.countryList.unshift(this.$data.defaultCountryList);

              let idFound = false;
              this.$data.countryList.forEach((item) =>{
                if (this.$data.countryId == item['countryId']) {
                idFound = true;
                }
              });
              if (idFound == false) {
                this.$data.countryId = this.$data.defaultCountryList.countryId;
              }

              
              if (this.$data.logLists) {
                console.log('this.$data.countryList = ', this.$data.countryList);
              }
            });
        },
    
        getCompanyList() {
          if (this.$data.logTrace) {console.log('*** getCompanyList ***');}

          axios
            .get(store.webAPIUrl + "Company/SelAllCompany")
            .then((response) => response.data)
            .then((data) => {
              this.$data.companyList = data;
              this.$data.companyList.unshift(this.$data.defaultCompanyList);

              let idFound = false;
              this.$data.companyList.forEach((item) =>{
                if (this.$data.companyId == item['companyId']) {
                  idFound = true;
                }
              });
              if (idFound == false) {
                this.$data.companyId = this.$data.defaultCompanyList.companyId;
              }
              
              if (this.$data.logLists) {
                console.log('this.$data.companyList = ', this.$data.companyList);
              }
            });
        },
    
        getCampLocationList() {
          if (this.$data.logTrace) {console.log('*** getCampLocationList ***');}

          axios
            .get(store.webAPIUrl + "CampLocation/SelAllCampLocation")
            .then((response) => response.data)
            .then((data) => {
              this.$data.campLocationList = data;
              this.$data.campLocationList.unshift(this.$data.defaultCampLocationList);

              let idFound = false;
              this.$data.campLocationList.forEach((item) =>{
                if (this.$data.campLocationId == item['campLocationId']) {
                  idFound = true;
                }
              });

              if (idFound == false) {
              this.$data.campLocationId = this.$data.defaultCampLocationList.campLocationId;
              }

              if (this.$data.logLists) {
                console.log('this.$data.campLocationList = ', this.$data.campLocationList);
              }
            });
        },
    
        getUserNameList() {
          if (this.$data.logTrace) {console.log('*** getUserNameList ***');}

          axios
            .get(store.webAPIUrl + "UserProfile/SelUniqueUserNames")
            .then((response) => response.data)
            .then((data) => {
              this.$data.userNamesList = data;

              if (this.$data.logLists) {
                console.log('this.$data.userNamesList = ', this.$data.userNamesList);
              }
            });
        },

        //---------------------- General Suport ----------------------------------

        formatDateFnc(value) {
          //Used to format dates passed to the HTML date control.
          let monthPart = value.substring(0, 2);
          let dayPart = value.substring(3, 5);
          let yearPart = value.substring(6, value.length);
          return yearPart + '-' + monthPart + '-' + dayPart;
        },

        logAllFields(){
          if (this.$data.logTrace) {console.log('*** logAllFields ***');}

          if (this.$data.logData) {
            console.log('this.$data.firstName = ', this.$data.firstName);
            console.log('this.$data.lastName = ', this.$data.lastName);
            console.log('this.$data.middleName = ', this.$data.middleName);
            console.log('this.$data.email = ', this.$data.email);
            console.log('this.$data.phone1 = ', this.$data.phone1);
            console.log('this.$data.title = ', this.$data.title);
            console.log('this.$data.userProfileNotes = ', this.$data.userProfileNotes);
            console.log('this.$data.certificatCommonName = ', this.$data.certificatCommonName);
            console.log('this.$data.userName = ', this.$data.userName);
            console.log('this.$data.serviceRankId = ', this.$data.serviceRankId);
            console.log('this.$data.roleId = ', this.$data.roleId);
            console.log('this.$data.countryId = ', this.$data.countryId);
            console.log('this.$data.companyId = ', this.$data.companyId);
            console.log('this.$data.campLocationId = ', this.$data.campLocationId);
            console.log('this.$data.isActive = ', this.$data.isActive);
            console.log('this.$data.deleted = ', this.$data.deleted);
          }
        },
  
      },
    };
</script>
    
<style scoped>
  
  option:first-of-type {
    color: blue;
  }

  .pageHeader {
    font-size: 24px;
    color: #000099;
  }
  
  /* ------------------ Controls --------------- */

  .nowrapAll {
    white-space: nowrap;
  }

  .groupMinWidth {
    min-width: 1100px;
  }
   
   .ctrlDropDown {
    height: 30px;
    padding: 5px;
  }
  
  .ctrlBorderRadius {
    border: 1px solid #d9d9d9;
    border-radius: 0px;
  }
  
  .ctrlTextPadding {
    padding: 3px;
  }
  
  .radioLabelMargin {
    margin-left: 5px;
  }

  /* ------------------- debug borders ------------------ */

  .borderPink {
    border: 0px pink solid;    
  }
  .borderBlue {
    border: 0px blue solid;    
  }
    .borderRed {
        border: 0px #DC143C solid;
    }

  /* ---------------- font ------------------- */
  
  .labelFont {
    font-weight: bold;
    color: black;
    font-size: 14px;
  }

  .ctrlFont {
    font-size: 14px;
  }
  
  .fontSizeBtn {
    font-size: 14px;
  }

  /* ---------------- container */
  
  .mainContainer {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 33% 33% 33%;
    margin-bottom: 0px;
    margin-top: 0px;
  }

  .itemCenterCenter {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .formContainer {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    width: 99%;
  }
  
  .leftRightRowContainer {
    display: grid;
    grid-template-columns: 40% 60%;
    grid-template-rows: repeat(5, 40px);
  }

  .leftRightRowContainerAlt {
    display: grid;
    grid-template-columns: 40% 60%;
    grid-template-rows: repeat(2, 40px);
  }

  .elementRight {
    margin-right: 10px;
    text-align: right;
  }
  
  .elementLeft {
    margin-right: 10px;
    text-align: left;
  }
  
  .pagesMainDiv {
    margin-top: 0px;
    margin-left: 0px;
    margin-bottom: 0px;
    padding-right: 0px;
    text-align: left;
    width: 100%;
  }
  
  /* ------------------- Validation ----------------- */

  .validationDiv {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: center;

  border: 1px solid darkred;
  width: 550px;
  padding: 25px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.validationHeaderDiv {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: darkblue;
}

.validationErrorAsterisk {
  margin-left: 2px;
}

    .highlightRed {
        color: #DC143C;
    }
.highlightDarkRed {
  color: darkred;
}

.divRequiredInstructions {
  color: black;
  font-size: 12px;
  margin-left: 15px;
  margin-bottom: 15px;
  margin-top: 10px;
}

/* ---------------------- Validation Table -------------------- */

.valTableMargin {
  margin-top: 15px;
  margin: 0 auto;
}
.valCell {
  border-top: 1px #e6e6e6 solid;
  border-bottom: 1px #e6e6e6 solid;
  padding: 8px;
  text-align: left;
}
.valCellLeft {
  border-top: 1px #e6e6e6 solid;
  border-bottom: 1px #e6e6e6 solid;
  border-right: 1px #e6e6e6 solid;
  padding: 8px;
  font-weight: bold;
  color: blue;
  text-align: left;
}

</style>
    